import * as actionTypes from "../../../actions/actionTypes";

const patientPersonalInfo = (
  state = {
    dataChanged: false,
    allergy: [],
    removedAllergy: [],
    medical_condition: [],
    family_medical_history: [],
    surgery_details: [],
    medication_details: [],
    removedMedicalCondition: [],
    removedFamilyMedicalHistory: [],
    removedSurgeryDetails: [],
    removedMedicationDetails: [],
    current_medicine_consumption_period: [],
    delete_medical_record_details: null,
    new_medical_record_details: null,
    update_medical_record_details: null,
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_PATIENT_PERSONAL_INFO: {
      return { ...state, dataChanged: true, ...action.payload };
    }
    case actionTypes.ADD_ALLERGIES: {
      const allergy = [...state.allergy];
      allergy.push(state.currentAllergy);
      return {
        ...state,
        dataChanged: true,
        allergy: allergy,
        currentAllergy: "",
      };
    }

    case actionTypes.REMOVE_ALLERGIES: {
      const allergy = [...state.allergy];
      const update_removed_allergy = [...state.removedAllergy];
      allergy[action.payload.index] &&
        update_removed_allergy.push(allergy[action.payload.index]);

      allergy.splice(action.payload.index, 1);
      return {
        ...state,
        dataChanged: true,
        allergy: allergy,
        removedAllergy: update_removed_allergy,
      };
    }

    case actionTypes.ADD_MEDICAL_CONDITION: {
      const medical_condition = [...state.medical_condition];
      medical_condition.push(state.current_medical_condition);

      return {
        ...state,
        dataChanged: true,
        medical_condition: medical_condition,
        current_medical_condition: "",
      };
    }

    case actionTypes.REMOVE_MEDICAL_CONDITION: {
      const medical_condition = [...state.medical_condition];
      const update_removed_medical_condition = [
        ...state.removedMedicalCondition,
      ];
      medical_condition[action.payload.index] &&
        update_removed_medical_condition.push(
          medical_condition[action.payload.index]
        );

      medical_condition.splice(action.payload.index, 1);
      return {
        ...state,
        dataChanged: true,
        medical_condition: medical_condition,
        removedMedicalCondition: update_removed_medical_condition,
      };
    }

    case actionTypes.ADD_FAMILY_MEDICAL_HISTORY: {
      const family_medical_history = [...state.family_medical_history];
      family_medical_history.push(state.current_family_medical_history);
      return {
        ...state,
        dataChanged: true,
        family_medical_history: family_medical_history,
        current_family_medical_history: "",
      };
    }

    case actionTypes.REMOVE_FAMILY_MEDICAL_HISTORY: {
      const family_medical_history = [...state.family_medical_history];
      const update_removed_family_medical_history = [
        ...state.removedFamilyMedicalHistory,
      ];
      family_medical_history[action.payload.index] &&
        update_removed_family_medical_history.push(
          family_medical_history[action.payload.index]
        );

      family_medical_history.splice(action.payload.index, 1);
      return {
        ...state,
        dataChanged: true,
        family_medical_history: family_medical_history,
        removedFamilyMedicalHistory: update_removed_family_medical_history,
      };
    }

    case actionTypes.ADD_PREVIOUS_SURGERY: {
      const surgery_details = [...state.surgery_details];
      surgery_details.push({
        surgery_name: state.current_surgery_name,
        surgery_date: state.current_surgery_date,
      });
      return {
        ...state,
        dataChanged: true,
        surgery_details: surgery_details,
        current_surgery_name: "",
        current_surgery_date: "",
      };
    }

    case actionTypes.SET_PREVIOUS_SURGERY: {
      const index = action.payload.index;
      const surgery_details = [...state.surgery_details];
      surgery_details[index] = {
        ...surgery_details[index],
        [action.payload.type]: action.payload.data,
      };

      return { ...state, dataChanged: true, surgery_details: surgery_details };
    }

    case actionTypes.REMOVE_PREVIOUS_SURGERY: {
      const surgery_details = [...state.surgery_details];
      const update_removed_surgery_details = [...state.removedSurgeryDetails];
      surgery_details[action.payload.index] &&
        update_removed_surgery_details.push(
          surgery_details[action.payload.index]
        );

      surgery_details.splice(action.payload.index, 1);
      return {
        ...state,
        dataChanged: true,
        surgery_details: surgery_details,
        removedSurgeryDetails: update_removed_surgery_details,
      };
    }

    case actionTypes.ADD_MEDICATION: {
      const medication_details = [...state.medication_details];
      medication_details.push({
        medicine_name: state.current_medicine_name,
        consumption: state.current_medicine_timing,
        medicine_consumption_period: state.current_medicine_consumption_period,
        dosage: state.current_dosage,
        instructions: state.current_instructions,
      });

      return {
        ...state,
        dataChanged: true,
        medication_details: medication_details,
        current_medicine_name: "",
        current_medicine_timing: "",
        current_medicine_consumption_period: [],
        current_dosage: "",
        current_instructions: "",
      };
    }

    case actionTypes.SET_MEDICATION: {
      const index = action.payload.index;
      const medication = [...state.medication_details];
      medication[index] = {
        ...medication[index],
        [action.payload.type]: action.payload.data,
      };

      return { ...state, dataChanged: true, medication_details: medication };
    }
    case actionTypes.REMOVE_MEDICATION: {
      const medication_details = [...state.medication_details];
      const update_removed_medication_details = [
        ...state.removedMedicationDetails,
      ];
      medication_details[action.payload.index] &&
        update_removed_medication_details.push(
          medication_details[action.payload.index]
        );

      medication_details.splice(action.payload.index, 1);
      return {
        ...state,
        dataChanged: true,
        medication_details: medication_details,
        removedMedicationDetails: update_removed_medication_details,
      };
    }

    case actionTypes.ADD_CURRENT_MEDICATION_TIME: {
      const updatedObj = [...state.current_medicine_consumption_period];

      if (!updatedObj.includes(action.payload.data))
        updatedObj.push(action.payload.data);
      else updatedObj.splice(updatedObj.indexOf(action.payload.data), 1);

      return {
        ...state,
        dataChanged: true,
        current_medicine_consumption_period: updatedObj,
      };
    }

    case actionTypes.ADD_MEDICATION_TIME: {
      const index = action.payload.index;
      const medication = [...state.medication_details];
      const timings = medication[index][action.payload.type];
      !timings.includes(action.payload.data)
        ? timings.push(action.payload.data)
        : timings.splice(timings.indexOf(action.payload.data), 1);
      medication[index] = {
        ...medication[index],
        [action.payload.type]: timings,
      };
      return { ...state, dataChanged: true, medication_details: medication };
    }

    default:
      return state;
  }
};

export default patientPersonalInfo;
